/* ============================================================
   LEOSPORTZ — theme-nav.js
   Navigation: mobile nav, sticky header, skip link,
   announcement bar, filter drawer.
   ============================================================ */

(function () {
'use strict';

window.Leosportz = window.Leosportz || {};
const { $, $$, on, throttle } = Leosportz.utils;

/* ─── Announcement Bar ────────────────────────────────────── */
Leosportz.AnnouncementBar = {
  init() {
    const bar = $('.announcement-bar');
    const close = $('.announcement-bar__close');
    if (!bar || !close) return;

    const key = 'lz_ann_closed';
    const stored = localStorage.getItem(key);
    if (stored) {
      const ts = parseInt(stored, 10);
      if (Date.now() - ts < 7 * 24 * 60 * 60 * 1000) { bar.remove(); return; }
    }

    on(close, 'click', () => {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        bar.style.maxHeight = '0';
        bar.style.opacity = '0';
      });
      setTimeout(() => bar.remove(), 320);
      localStorage.setItem(key, Date.now().toString());
    });
  },
};

/* ─── Mobile Nav ──────────────────────────────────────────── */
Leosportz.MobileNav = {
  init() {
    const hamburger = $('.site-header__hamburger');
    const overlay = $('.mobile-nav-overlay');
    const drawer = $('.mobile-nav');
    if (!hamburger || !drawer) return;

    const open = () => { drawer.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; };

    on(hamburger, 'click', open);
    on(overlay, 'click', close);
    $$('.mobile-nav__close, [data-mobile-nav-close]').forEach(el => on(el, 'click', close));
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
  },
};

/* ─── Sticky Header ───────────────────────────────────────── */
Leosportz.StickyHeader = {
  init() {
    const header = $('.site-header');
    const nav = $('.site-header__nav');
    const search = $('.site-header__search');
    if (!header) return;

    const onScroll = throttle(() => {
      const y = window.scrollY;
      const isStuck = y > 60;
      header.classList.toggle('is-stuck', isStuck);
      header.classList.toggle('is-collapsed', y > 200);
    }, 50);

    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  },
};

/* ─── Skip Link ───────────────────────────────────────────── */
Leosportz.SkipLink = {
  init() {
    const skip = $('.skip-link');
    const main = $('#main-content');
    if (!skip || !main) return;
    on(skip, 'click', e => {
      e.preventDefault();
      main.focus();
      main.scrollIntoView({ behavior: 'smooth' });
    });
  },
};

/* ─── Filter Drawer (mobile) ──────────────────────────────── */
Leosportz.FilterDrawer = {
  init() {
    const sidebar = document.getElementById('filter-sidebar');
    const openBtn = document.querySelector('[data-filter-toggle]');
    const closeBtn = document.querySelector('[data-filter-close]');
    const overlay = document.querySelector('[data-filter-overlay]');
    if (!sidebar || !openBtn) return;

    const open = () => { sidebar.classList.add('is-mobile-open'); document.body.style.overflow = 'hidden'; };
    const close = () => { sidebar.classList.remove('is-mobile-open'); document.body.style.overflow = ''; };

    on(openBtn, 'click', open);
    on(closeBtn, 'click', close);
    on(overlay, 'click', close);
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
  },
};

/* ─── Price Range Filter ──────────────────────────────────── */
Leosportz.PriceRange = {
  init() {
    const slider = document.querySelector('[data-price-range]');
    const label = document.querySelector('[data-price-label]');
    if (!slider) return;

    const buildUrl = (maxPrice) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      const rangeMin = parseInt(slider.dataset.rangeMin || '0', 10) / 100;
      url.searchParams.set('filter.v.price.gte', rangeMin);
      url.searchParams.set('filter.v.price.lte', maxPrice);
      return url.toString();
    };

    on(slider, 'input', () => {
      if (label) {
        const val = parseInt(slider.value, 10);
        label.textContent = 'Rs. ' + val.toLocaleString('en-IN');
      }
    });

    on(slider, 'change', () => {
      window.location.href = buildUrl(parseInt(slider.value, 10));
    });
  },
};

/* ─── Filter Group Toggle (accordion) ─────────────────────── */
Leosportz.FilterAccordion = {
  init() {
    document.querySelectorAll('.filter-group__toggle').forEach(toggle => {
      on(toggle, 'click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !expanded);
        const body = document.getElementById(toggle.getAttribute('aria-controls'));
        if (body) body.style.display = expanded ? 'none' : '';
        const icon = toggle.querySelector('.material-symbols-outlined');
        if (icon) icon.textContent = expanded ? 'expand_more' : 'expand_less';
      });
    });
  },
};

Leosportz.CopyCode = {
  init() {
    document.querySelectorAll('.pdp-offer-tag__copy').forEach(btn => {
      on(btn, 'click', async () => {
        const code = btn.dataset.copy;
        if (!code) return;
        try {
          await navigator.clipboard.writeText(code);
          const icon = btn.querySelector('.material-symbols-outlined');
          if (icon) icon.textContent = 'check';
          btn.classList.add('copied');
          setTimeout(() => {
            if (icon) icon.textContent = 'content_copy';
            btn.classList.remove('copied');
          }, 1200);
        } catch (err) {
          // fallback: silent fail
        }
      });
    });
  },
};

Leosportz.CopyCode.init();

})();
